var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchAwsThinkboxDeadline32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture/32/Arch_AWS-ThinkBox-Deadline_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8511B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture/32/Arch_AWS-ThinkBox-Deadline_32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon-Service/32/AWS-ThinkBox-Deadline_32",
    transform: "translate(4.000000, 4.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27,22.1983907 L17,27.6533907 L17,22.5193907 L21.51,20.0593907 L23.449,21.0293907 L23.896,20.1343907 L22,19.1863907 L22,13.1803907 L27,10.3523907 L27,22.1983907 Z M11,24.6533907 L11,19.5193907 L14,17.8833907 L14,18.4953907 C14,18.6793907 14.102,18.8493907 14.264,18.9363907 C14.338,18.9753907 14.419,18.9953907 14.5,18.9953907 C14.597,18.9953907 14.693,18.9673907 14.777,18.9113907 L16,18.0963907 L16,21.9263907 L11,24.6533907 Z M5,21.6533907 L5,9.79239072 L15,4.33739072 L15,9.47139072 L10.49,11.9313907 L8.447,10.9093907 L8,11.8043907 L10,12.8043907 L10,18.9263907 L5,21.6533907 Z M17.777,16.9113907 C17.916,16.8183907 18,16.6623907 18,16.4953907 L18,15.4423907 L21,13.7453907 L21,19.1983907 L17,21.3803907 L17,17.4953907 L16.901,17.4953907 L17.777,16.9113907 Z M15,15.7623907 L17,14.4293907 L17,16.2273907 L15,17.5613907 L15,15.7623907 Z M14.223,15.0793907 C14.084,15.1723907 14,15.3283907 14,15.4953907 L14,16.7433907 L11,18.3803907 L11,12.7923907 L15,10.6103907 L15,14.5613907 L14.223,15.0793907 Z M21,7.33739072 L21,12.5973907 L18,14.2933907 L18,13.4953907 C18,13.3103907 17.898,13.1413907 17.736,13.0543907 C17.573,12.9683907 17.377,12.9763907 17.223,13.0793907 L16,13.8943907 L16,10.0643907 L21,7.33739072 Z M27.752,9.06339072 C27.742,9.05739072 27.729,9.05939072 27.719,9.05439072 L27.723,9.04739072 L25.301,7.84539072 L24.855,8.74039072 L26.434,9.52439072 L22,12.0313907 L22,6.49539072 C22,6.31939072 21.907,6.15539072 21.755,6.06539072 C21.604,5.97539072 21.415,5.97239072 21.261,6.05639072 L16,8.92639072 L16,4.30439072 L17.725,5.16639072 L18.172,4.27239072 L15.724,3.04839072 L15.72,3.05539072 C15.575,2.98439072 15.404,2.97839072 15.261,3.05639072 L4.261,9.05639072 C4.1,9.14339072 4,9.31239072 4,9.49539072 L4,22.4953907 C4,22.6713907 4.093,22.8353907 4.245,22.9253907 C4.256,22.9313907 4.27,22.9293907 4.28,22.9353907 L4.276,22.9423907 L6.836,24.2223907 L7.283,23.3273907 L5.579,22.4753907 L10,20.0643907 L10,25.4953907 C10,25.6713907 10.093,25.8353907 10.245,25.9253907 C10.323,25.9713907 10.412,25.9953907 10.5,25.9953907 C10.582,25.9953907 10.665,25.9743907 10.739,25.9343907 L16,23.0643907 L16,27.6863907 L13.984,26.6783907 L13.537,27.5733907 L16.276,28.9423907 L16.28,28.9353907 C16.35,28.9693907 16.424,28.9953907 16.5,28.9953907 C16.582,28.9953907 16.665,28.9743907 16.739,28.9343907 L27.739,22.9343907 C27.9,22.8463907 28,22.6783907 28,22.4953907 L28,9.49539072 C28,9.31739072 27.905,9.15339072 27.752,9.06339072 L27.752,9.06339072 Z",
    id: "AWS-ThinkBox-Deadline_32_Squid"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchAwsThinkboxDeadline32);
export default __webpack_public_path__ + "static/media/Arch_AWS-Thinkbox-Deadline_32.d2a4735c30fa375a477e37a8de225655.svg";
export { ForwardRef as ReactComponent };